<template>
  <form
    ref="newsletterForm"
    :id="'newsletter-input-form_' + newsletterPopop && 'popop_' + _uid"
    method="post"
    @submit.prevent="validateData"
  >
    <div class="form-group">
      <div class="form-input" data-validate="mail">
        <input
          @focus="loadRecaptcha = true"
          type="email"
          autocomplete="email"
          :placeholder="multiLanguage.NewsletterPlaceHolder"
          :id="'email-input-id_' + newsletterPopop && 'popop_' + _uid"
          v-model="email"
          data-testing="mail"
        />

        <div class="d-none error-feedback my-1">
          {{ $translate("Ceres::Template.contactEnterConfirmEmail") }}
        </div>
        <div
          v-if="newsletterPopop && success"
          class="d-none success-feedback my-2"
        >
          {{
            multiLanguage.NewsletterSubscribe.replace("{email}", cachedEmail)
          }}
        </div>
      </div>

      <div class="form-btn">
        <button
          type="button"
          class="btn btn-block btn-primary"
          @click="validateData"
          :disabled="isDisabled"
          data-testing="nl-send"
        >
          {{ $translate("Ceres::Template.newsletterSubscribeButtonLabel") }}
        </button>
      </div>

      <div
        class="form-check small mt-3"
        data-validate
        v-if="showPrivacyPolicyCheckbox"
      >
        <input
          type="checkbox"
          class="form-check-input"
          :id="'privacy-policy-accept-id_' + newsletterPopop && 'popop_' + _uid"
          name="privacy-policy-accept"
          v-model="privacyPolicyValue"
          data-testing="nl-policy"
          aria-label="checkbox"
        />
        <label
          :for="
            'privacy-policy-accept-id_' + newsletterPopop && 'popop_' + _uid
          "
          class="form-check-label"
          v-html="privacyPolicyText"
        ></label>
      </div>
    </div>
    <recaptcha
      v-if="!!$ceres.config.global.googleRecaptchaApiKey && loadRecaptcha"
    ></recaptcha>
  </form>
</template>

<script>
import ApiService from "../../services/ApiService";
import NotificationService from "../../services/NotificationService";
import ValidationService from "../../services/ValidationService";
import { executeReCaptcha } from "../../helper/executeReCaptcha";

export default {
  props: {
    showPrivacyPolicyCheckbox: {
      type: Boolean,
      default: false,
    },
    emailFolder: {
      type: Number,
      default: 0,
    },
    newsletterPopop: {
      type: Boolean,
      default: false,
    },
    multiLanguage: Object,
  },
  data() {
    return {
      email: "",
      cachedEmail: "",
      isDisabled: false,
      privacyPolicyValue: false,
      honeypot: "",
      success: false,
      loadRecaptcha: false,
    };
  },
  computed: {
    privacyPolicyText() {
      const link =
        '<a href="' +
        App.urls.privacyPolicy +
        '" target="_blank"><span class="text-appearance">' +
        this.$translate("Ceres::Template.checkoutPrivacyPolicy", {
          hyphen: "&shy;",
        }) +
        "</span></a>";
      return (
        this.$translate("Ceres::Template.newsletterAcceptPrivacyPolicy", {
          policy: link,
        }) + this.$translate("Ceres::Template.newsletterIsRequiredFootnote")
      );
    },
  },
  methods: {
    validateData() {
      this.isDisabled = true;
      ValidationService.validate(
        $("#newsletter-input-form_" + newsletterPopop && "popop_" + this._uid)
      )
        .done(() => {
          this.save();
        })
        .fail((invalidFields) => {
          ValidationService.markInvalidFields(invalidFields, "error");
          invalidFields
            .filter((field) => {
              return field.dataset.validate !== null;
            })
            .map((field) => {
              return {
                type: field.dataset.validate,
                name: field.innerText,
              };
            })
            .forEach((field) => {
              if (field.type === "!regex") {
                NotificationService.error(
                  this.$translate(
                    "Ceres::Template.newsletterNotAllowedCharacters",
                    { name: field.name }
                  )
                ).closeAfter(5000);
              }
            });
          this.isDisabled = false;
        });
    },
    save() {
      const recaptchaEl = this.$el.querySelector("[data-recaptcha]");
      if (
        App.config.global.googleRecaptchaApiKey &&
        (!window.grecaptcha || !recaptchaEl)
      ) {
        NotificationService.error(
          this.$translate("Ceres::Template.newsletterAcceptRecaptchaCookie")
        ).closeAfter(5000);
        this.isDisabled = false;
        return;
      }
      executeReCaptcha(this.$el).then((recaptchaToken) => {
        ApiService.post("/rest/io/customer/newsletter", {
          email: this.email,
          emailFolder: this.emailFolder,
          honeypot: this.honeypot,
          recaptcha: recaptchaToken,
        })
          .done((data) => {
            if (!!data.containsHoneypot) {
              NotificationService.warn(
                this.$translate("Ceres::Template.newsletterHoneypotWarning")
              ).closeAfter(5000);
            } else {
              NotificationService.success(
                this.$translate("Ceres::Template.newsletterSuccessMessage")
              ).closeAfter(3000);
            }
            this.success = true;
            if (this.$props.newsletterPopop) {
              this.cachedEmail = this.email;
            }
            this.resetInputs();
          })
          .fail(() => {
            NotificationService.error(
              this.$translate("Ceres::Template.newsletterErrorMessage")
            ).closeAfter(5000);
          })
          .always(() => {
            this.isDisabled = false;
            this.resetRecaptcha();
          });
      });
    },
    resetInputs() {
      this.email = "";
      this.privacyPolicyValue = false;
    },
    resetRecaptcha() {
      if (App.config.global.googleRecaptchaVersion === 2 && window.grecaptcha) {
        const recaptchaId = this.$el.querySelector("[data-recaptcha]");
        window.grecaptcha.reset(recaptchaId);
      }
    },
  },
};
</script>
